import { Box } from '@mui/material'
import { useEatInLocationInline } from '~/src/hooks/delivery-methods/useEatInLocationInline'
import TableRestaurantIcon from '@mui/icons-material/TableRestaurant'

const EatInSummary = () => {
  const { sentence } = useEatInLocationInline()

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1,
        backgroundColor: 'secondary.main',
        color: 'secondary.contrastText'
      }}
    >
      <TableRestaurantIcon color='primary'/> {sentence}
    </Box>
  )
}

export default EatInSummary
